import { render } from "./PaisesCiudadesTab.vue?vue&type=template&id=1aea2bb7"
import script from "./PaisesCiudadesTab.vue?vue&type=script&lang=js"
export * from "./PaisesCiudadesTab.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__